import { Stack, Typography, useTheme } from "@mui/material";

import { RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";

export const Section4 = ({ methods }: any) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        flex: 1,
        minWidth: { xs: "100%", sm: "48%" },
        border: `1px solid ${
          methods?.formState?.errors?.carInfo?.carCondition
            ? theme.palette.error.main
            : theme.palette.grey[300]
        }`,
        borderRadius: 1,
        flexDirection: "column",
        p: 2,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}>
        {Strings.step.carInfo.carCondition}
      </Typography>
      <Stack flex={1} justifyContent={"space-evenly"}>
        <Stack
          flexDirection={"row"}
          width={"100%"}
          flexWrap={"wrap"}
          justifyContent={"space-between"}
        >
          <RHFRadioSingle
            name={"carInfo.carCondition"}
            value={Strings.step.carInfo.excellent}
            label={Strings.step.carInfo.excellent}
          />
          <RHFRadioSingle
            name={"carInfo.carCondition"}
            value={Strings.step.carInfo.good}
            label={Strings.step.carInfo.good}
          />
        </Stack>
        <Stack
          flexDirection={"row"}
          width={"100%"}
          flexWrap={"wrap"}
          justifyContent={"space-between"}
        >
          <RHFRadioSingle
            name={"carInfo.carCondition"}
            value={Strings.step.carInfo.average}
            label={Strings.step.carInfo.average}
          />
          <RHFRadioSingle
            name={"carInfo.carCondition"}
            value={Strings.step.carInfo.needsWork}
            label={Strings.step.carInfo.needsWork}
          />
        </Stack>
      </Stack>
      {methods?.formState?.errors?.carInfo?.carCondition && (
        <Typography color="error" variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
          {methods.formState.errors.carInfo.carCondition.message}
        </Typography>
      )}
    </Stack>
  );
};
